export const AmenitiesEndpoints = {
  getAmenityDetails: `/admin/getAmenities?`,
  updateRequestStatus: `/admin/common/action-on-request`,
  addAmenities:`/admin/addAmenities`,
  editAmenities:`/admin/updateAmenities`,
  deleteAminity:`/admin/deleteAmenities/`,
};
